(function() {
    angular
        .module("loginModule")
        .controller("ResetPasswordController", ResetPasswordController)

    ResetPasswordController.$inject = [
        "$stateParams",
        "$state",
        "$rootScope",
        "$scope",
        "authenticationService",
        "usersService",
        "userMessagingService"
    ]

    function ResetPasswordController(
        $stateParams,
        $state,
        $rootScope,
        $scope,
        authenticationService,
        usersService,
        userMessagingService
    ){
        "use strict"

        authenticationService.logoutSoft()

        /**
            $rootScope variables
         **/
        $rootScope.title = "Reset Password | WANCO"

        /**
            $scope variables
         **/
        $scope.resetPasswordFormData = {
            "reset_password_token": $stateParams.password_reset_token
        }

        /**
            Check password match
         **/
        $scope.checkPasswordMatch = function() {
            $scope.passwordMatch = $scope.resetPasswordFormData.password_confirmation == $scope.resetPasswordFormData.password
        }

        /**
            Reset password
         **/
        $scope.resetPassword = function() {
            $scope.submitted = true
            $scope.formSuccess = false
            if ($scope.resetPasswordFormData.password_confirmation !== $scope.resetPasswordFormData.password) {
                $scope.passwordMatch = false
                $scope.resetPasswordForm.$valid = false
            } else {
                $scope.passwordMatch = true
            }
            if ($scope.resetPasswordForm.$valid) {
                usersService.resetPassword(
                    angular.fromJson($scope.resetPasswordFormData),
                    function() {
                        //Success
                        $state.go("login").then(() => {
                            userMessagingService.success("Password Reset Successful")
                        })
                    },
                    function(error) {
                        //Failure
                        userMessagingService.error(error)
                    }
                )
            }
        }
    }
})()
